import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "../components/layout/Layout";
import Home from "../pages/home/page";
import Updates from "../pages/updates/page";
import Category from "../pages/category/page";
import Article from "../pages/article/page";
import Faq from "../pages/faq/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/updates", element: <Updates /> },
      { path: "/category/:slug", element: <Category /> },
      { path: "/article/:slug", element: <Article /> },
      { path: "/faq", element: <Faq /> },
      { path: "/about", element: <About /> },
      { path: "/contact", element: <Contact /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;